import { Center, Loader } from '@conexasaude/conexa-hero'
import { memo } from 'react'

export const LoadingChat = memo(() => {
  return (
    <Center>
      <Loader />
    </Center>
  )
})

LoadingChat.displayName = 'LoadingChat'
